// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"89b0a831","596":"ac8b026a"}[chunkId] + ".chunk.js";
};